// extracted by mini-css-extract-plugin
export var bodyRow = "_fv-d";
export var cardColumns = "_fv-e";
export var ellipsesOverflow = "_fv-2";
export var flatBottomCorners = "_fv-3";
export var flatTopCorners = "_fv-4";
export var headerActionsDropdown = "_fv-f";
export var headerBottomRow = "_fv-c";
export var headerTopRow = "_fv-b";
export var orderDetailsWrapper = "_fv-0";
export var orderInfoContainer = "_fv-1";
export var productDetails = "_fv-9";
export var productImage = "_fv-5";
export var responsiveTable = "_fv-8";
export var shipmentContainer = "_fv-a";
export var tableBottomLeft = "_fv-6";
export var tableBottomRight = "_fv-7";
export var trackingLink = "_fv-g";